module.exports = __webpack_public_path__ + "img/full0-min.b433fe49.png";